export default "__VITE_PUBLIC_ASSET__fe3aeb2a__"